import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { isSameDay, isToday } from '../utils/dates';

@Pipe({
  name: 'truncate'
})
/**
 * limita tamanho da string
 */
export class TruncateStringPipe implements PipeTransform {


  transform(s: string, max: number )  {
    if (s && s.length > max) {
      return s.substring(0, max) + '...'
    }
    return s
  }

}
